// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"3":"d5a26c0b","815":"9baae58b"}[chunkId] + ".chunk.css";
};